import { ErrorBoundary } from "@datadog/browser-rum-react";
import FailureError from "core/error/FailureError";
import { ERROR_TYPES } from "core/constants";

const AuthErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => {
        console.info("AuthErrorBoundary", error);

        return (
          <FailureError
            resetError={resetError}
            type={ERROR_TYPES.AUTH_ERROR}
            error={error}
          />
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default AuthErrorBoundary;
